import React from 'react';
import { Mail, Send } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

const ContactSection = () => {
  const { t } = useTranslation();
  const email = 'songstorepresent@gmail.com';

  const handleEmailClick = () => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <section id="kontakt" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black">
            {t('contact.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('contact.subtitle')}
          </p>
          <div className="w-20 h-1 bg-black mx-auto"></div>
        </div>

        {/* Contact Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-2 border-gray-100">
          <div className="text-center space-y-8">
            {/* Email Icon */}
            <div className="flex justify-center">
              <div className="p-6 bg-black rounded-full">
                <Mail className="w-12 h-12 text-white" />
              </div>
            </div>

            {/* Email Address */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-black">
                {t('contact.emailTitle')}
              </h3>
              <a
                href={`mailto:${email}`}
                className="text-2xl md:text-3xl font-semibold text-black hover:text-gray-600 transition-colors duration-200 inline-block"
              >
                {email}
              </a>
            </div>

            {/* CTA Button */}
            <div className="pt-4">
              <Button
                onClick={handleEmailClick}
                size="lg"
                className="bg-black text-white hover:bg-gray-800 transition-all duration-300 px-8 py-6 text-lg font-semibold group"
              >
                <Send className="w-5 h-5 mr-2 group-hover:translate-x-1 transition-transform duration-200" />
                {t('contact.sendButton')}
              </Button>
            </div>

            {/* Additional Info */}
            <div className="pt-8 border-t-2 border-gray-100">
              <p className="text-gray-600 leading-relaxed">
                {t('contact.info')}
              </p>
            </div>
          </div>
        </div>

        {/* Additional Contact Info */}
        <div className="mt-12 grid md:grid-cols-3 gap-6 text-center">
          <div className="p-6">
            <h4 className="font-semibold text-black mb-2">{t('contact.feature1Title')}</h4>
            <p className="text-gray-600 text-sm">{t('contact.feature1Desc')}</p>
          </div>
          <div className="p-6">
            <h4 className="font-semibold text-black mb-2">{t('contact.feature2Title')}</h4>
            <p className="text-gray-600 text-sm">{t('contact.feature2Desc')}</p>
          </div>
          <div className="p-6">
            <h4 className="font-semibold text-black mb-2">{t('contact.feature3Title')}</h4>
            <p className="text-gray-600 text-sm">{t('contact.feature3Desc')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;